import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  HStack,
  Heading,
  Divider,
  Box,
  Image,
  Card,
  CardBody,
  LinkBox,
  LinkOverlay,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import singlePhaseImage from '../../../assets/projects/single-phase-project.svg';
import multiplePhasesImage from '../../../assets/projects/multiple-phases-project.svg';

export const NewProjectModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      blockScrollOnMount={false}
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
    >
      <ModalOverlay />

      <ModalContent pb="4">
        <ModalHeader>
          <Heading fontSize="md" fontWeight="semibold" color="custom_blue.1">
            Choose a Project Type
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Divider mb="4" />
          <HStack justify="space-between">
            <LinkBox flexBasis="48%">
              <LinkOverlay as={Link} to="/projects/single-phase/new-project">
                <Card
                  boxShadow="0 12px 16px -4px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.03)"
                  px="6"
                  py="7"
                >
                  <CardBody
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                    color="custom_blue.1"
                    textAlign="center"
                  >
                    <Image src={singlePhaseImage} mb="4" />

                    <Box fontWeight="bold" fontSize="2xl" mb="4">
                      Single Phase Project
                    </Box>

                    <Box opacity=".7" fontSize="sm">
                      This Project has only one phase.
                    </Box>
                  </CardBody>
                </Card>
              </LinkOverlay>
            </LinkBox>

            <LinkBox flexBasis="48%">
              <LinkOverlay as={Link} to="/projects/multiple-phase/new-project">
                <Card
                  boxShadow="0 12px 16px -4px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.03)"
                  px="6"
                  py="7"
                >
                  <CardBody
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                    color="custom_blue.1"
                    textAlign="center"
                  >
                    <Image src={multiplePhasesImage} mb="4" />

                    <Box fontWeight="bold" fontSize="2xl" mb="4">
                      Multiple Phases Project
                    </Box>

                    <Box opacity=".7" fontSize="sm">
                      This Project includes more than one phase.
                    </Box>
                  </CardBody>
                </Card>
              </LinkOverlay>
            </LinkBox>
          </HStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
